// extracted by mini-css-extract-plugin
module.exports = {"container":"get_channel_ad_container__16YK0","text":"get_channel_ad_text__1rYvh"};